/* src/app/shared/navigation-buttons/navigation-buttons.component.scss */
:host {
  width: 100%;
}
:host .buttons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px 20px 20px;
}
:host .buttons .button {
  flex: 0 0 30%;
  display: flex;
  height: 60px;
  border-radius: 30px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
}
:host .buttons .button.start_of_note_flow {
  flex: 0 0 100%;
}
:host .buttons .button.end_of_note_flow {
  flex: 0 0 47%;
}
:host .buttons .button.two_buttons_showing {
  flex: 0 0 47%;
}
:host .buttons .button:disabled {
  opacity: 0.45;
}
:host .buttons .button_main {
  background: var(--ion-color-primary-lightblue);
  color: var(--ion-color-primary-darkgreen);
}
:host .buttons .button_secondary {
  background-color: transparent;
  border: 2px solid var(--ion-color-primary-lightblue);
  color: var(--ion-color-primary-contrast);
}
/*# sourceMappingURL=navigation-buttons.component.css.map */
